import { useTrackingService } from '@libs/client'
import { sleep } from '@ui/helpers'
import { useCatalog, useCatalogConfig, useRedirect } from '@ui/hooks'
import { useEffect, useState } from 'react'
import css from 'styled-jsx/css'
import SfLink from '../next/SfLink'
import ProductItem from '../product-item/ProductItem'
import CatalogLoading from './CatalogLoading'

export default function Catalog() {
  const [catalog] = useCatalog()
  const [configCollection] = useCatalogConfig()

  const redirect = useRedirect()
  const { trackingViewItem } = useTrackingService()
  useEffect(() => {
    //TODO: tracking
    trackingViewItem()
    if (!catalog) {
      redirect('/', { keepQuery: false })
    }
  }, [])

  const [currentCatalog, setCurrentCatalog] = useState('')
  useEffect(() => {
    ;(async () => {
      await sleep(250)
      setCurrentCatalog(configCollection?.label || '')
    })()
  }, [configCollection])

  const isEmptyCategory = !catalog || !Object.keys(catalog || {})?.length

  return !!currentCatalog && currentCatalog != configCollection?.label ? (
    <CatalogLoading />
  ) : (
    <>
      <div className="banner-collection">
        <h1 className="header-5">{configCollection?.label}</h1>
        <div
          className="body-1"
          dangerouslySetInnerHTML={{
            __html: configCollection?.top_description || ''
          }}
        />
      </div>

      <div className="has-bg-white">
        <div className={`ministore-catalog container-beva ${isEmptyCategory ? 'no-catalog' : ''}`}>
          <style jsx global>
            {globalStyle}
          </style>
          <div className="columns">
            {!isEmptyCategory ? (
              Object.entries(catalog).map(([subpath, item]) => (
                <div key={subpath} className="column is-12-mobile is-4-tablet is-3-desktop">
                  {item?.is_coming_soon || item?.soldout ? (
                    <div className="not-href-link">
                      <ProductItem item={item} />
                    </div>
                  ) : (
                    <SfLink pathName={`/p/${subpath}`}>
                      <ProductItem item={item} />
                    </SfLink>
                  )}
                </div>
              ))
            ) : (
              <div className="no-catalog__content">
                Thanks for stopping by! <br />
                Our bras are being restocked. Stay tuned for our latest selections, tailored for
                your comfort.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

const globalStyle = css.global`
  .banner-collection {
    background-color: var(--primary-10);
    color: var(--gray-8);
    padding: 32px 24px;
    text-align: center;

    h2 {
      color: var(--gray-9);
      margin-bottom: 8px;
    }

    div {
      max-width: 930px;
      margin: auto;
    }
  }
  .ministore-catalog {
    padding-top: 24px;
    padding-bottom: 72px;
    .columns {
      flex-wrap: wrap;
      grid-row-gap: 48px;
      margin-top: 0px;
      margin-bottom: 0px;
      .column {
        padding: 0 12px;

        &:last-child {
          .info {
            border-bottom: none;
          }
        }
      }
      .not-href-link {
        cursor: auto;
      }
    }
  }
  .no-catalog {
    padding: 40px 16px 48px;

    .columns {
      margin: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__content {
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      color: #363636;
      max-width: 791px;
    }
  }
  @media screen and (min-width: 768px) {
    .banner-collection {
      padding-left: 32px;
      padding-right: 32px;
    }
    .ministore-catalog {
      padding-top: 50px;
      padding-bottom: 102px;
    }

    .no-catalog {
      padding: 140px 16px 217px;
      &__content {
        text-align: center;

        font-size: 24px;
        line-height: 44px;
        color: #363636;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .ministore-catalog {
      .columns {
        grid-row-gap: 72px;
      }
    }
  }
`
